//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CostForwardingWarningType } from "models/utilTypes/costForwardingTypes";
//#endregion

const { InvoiceSendMethod, InvoiceStatus, WarningCategory } = WintSuperkollAPIModel;

/**
 * Body and query for POST api/Invoice/Warnings. The forwarded cost ids stay in the body because the server checks
 * their source documents; it only reads them there, so the request can never reserve a cost.
 */
const getInvoiceWarningsRequest = (
  invoicePost: WintSuperkollAPIModel.InvoicePost,
  invoice: { id?: number; status?: WintSuperkollAPIModel.InvoiceStatus }
) => ({
  body: invoicePost,
  // A reopened draft posts no forwarded cost ids, so the server needs the id to find the costs saved on it.
  params: invoice.id !== undefined && invoice.status === InvoiceStatus.NotSent ? { invoiceId: invoice.id } : undefined,
});

// Forwarded-cost warnings are left out on purpose: they concern the rows, so Slutgranska shows them inline for every
// send method instead of as floating messages.
const getWarningCategoriesShownFor = (sendMethod: WintSuperkollAPIModel.InvoiceSendMethod): number[] => {
  switch (sendMethod) {
    case InvoiceSendMethod.Email:
    case InvoiceSendMethod.MarkAsSent:
      return [WarningCategory.AutogiroWarnings, WarningCategory.EUVATWarnings];
    case InvoiceSendMethod.Print:
      return [
        WarningCategory.EUVATWarnings,
        WarningCategory.AutogiroWarningsWithReceipt,
        WarningCategory.Printing,
        WarningCategory.EInvoicing,
      ];
    default:
      return [];
  }
};

/** The warnings for forwarded costs whose receipt or supplier invoice was cancelled, denied or sent back. */
const getForwardedCostWarnings = (warnings?: WintSuperkollAPIModel.Warning[]) =>
  (warnings ?? []).filter((w) => (w.type as number) === CostForwardingWarningType.ForwardedCostSourceDocumentCancelled);

const InvoiceWarningHelper = { getInvoiceWarningsRequest, getWarningCategoriesShownFor, getForwardedCostWarnings };

export default InvoiceWarningHelper;
